import { Button } from "@components/ui/Button"
import { NonIdealState } from "@components/ui/NonIdealState"
import { Link } from "eddev/routing"

export function PlannerPanel() {
  return (
    <NonIdealState
      icon="bookmark"
      title="There's nothing in your planner"
      description="Look for the bookmark icon on any film to add it to your planner."
      actions={
        <>
          <Link href="/browse" as={Button}>
            View Program
          </Link>
        </>
      }
    />
  )
}
